const styles = {
    optInputField: {
        width: '2.5rem',
        height: '2.5rem',
        textAlign: 'center',
        fontSize: '1.5rem',
        border: '1px solid #ccc',
        borderRadius: '4px'
    }
}

export default styles;